import React, { useState } from "react";
import DownIcon from "mdi-react/ChevronDownIcon";
import { Collapse } from "reactstrap";
import { UserProps } from "src/shared/prop-types/ReducerProps";
import { ITC_ADMIN_ROLE_ID, MERCHANT_ROLE_ID, SECURITY_ROLE_ID } from '../../../utils/pnd/PndConstants';
import PndRestApi from "src/utils/pnd/PndRestApi";
import { FaSignOutAlt, FaUserCircle } from 'react-icons/fa';

const Ava = `../../../../../../img/pnd/profileAva.jpg`;

const TopbarProfile = ({ user, productRoute }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleProfile = () => setIsCollapsed(!isCollapsed);

  const clientName = localStorage.getItem("clientName") || "User";
  const uri = localStorage.getItem("uri") || "";

  const getRoleName = () => {
    if (uri === ITC_ADMIN_ROLE_ID) return "ITC Admin";
    if (uri === MERCHANT_ROLE_ID) return "Merchant";
    if (uri === SECURITY_ROLE_ID) return "Security";
    return "User";
  };

  const getLogoutPath = () => {
    if (uri === ITC_ADMIN_ROLE_ID) return "/itcadmin";
    if (uri === MERCHANT_ROLE_ID) return "/merchant";
    if (uri === SECURITY_ROLE_ID) return "/security";
    return "/";
  };

  const logout = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.Logout();
      if (response.status === 200 && response.data.status === 200) {
        localStorage.removeItem("_grecaptcha");
        localStorage.removeItem("uri");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("clientName");
        localStorage.removeItem("subscriptionEndDateInDays");
        localStorage.removeItem("theme-ui-color-mode");
        localStorage.removeItem("ui");
        localStorage.removeItem("ut");
        window.location.href = getLogoutPath();
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="topbar__profile">
      <button className="topbar__avatar" type="button" onClick={toggleProfile} style={{ padding: '0 8px', border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <div style={{
          width: '38px',
          height: '38px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          transition: 'transform 0.2s',
        }}>
          <span style={{ color: 'white', fontSize: '0.78rem', fontWeight: 700, letterSpacing: '0.5px' }}>
            {clientName?.slice(0, 2)?.toUpperCase() || 'U'}
          </span>
        </div>
        <span style={{ fontSize: '0.82rem', fontWeight: 600, color: '#333', display: 'none' }} className="d-md-inline">
          {clientName}
        </span>
        <DownIcon className="topbar__icon" />
      </button>

      {isCollapsed && (
        <button
          className="topbar__back"
          type="button"
          aria-label="profile button"
          onClick={toggleProfile}
        />
      )}

      <Collapse isOpen={isCollapsed} className="topbar__menu-wrap">
        <div className="topbar__menu" style={{ minWidth: '240px', padding: 0, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}>

          {/* Profile Info Card */}
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '18px 16px',
            textAlign: 'center',
            color: 'white'
          }}>
            <div style={{
              width: '56px', height: '56px', borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 10px'
            }}>
              <FaUserCircle style={{ fontSize: '2.2rem', color: 'white' }} />
            </div>
            <p style={{ margin: 0, fontWeight: 700, fontSize: '0.95rem', letterSpacing: '0.3px' }}>{clientName}</p>
            <span style={{
              display: 'inline-block', marginTop: '5px',
              background: 'rgba(255,255,255,0.25)',
              padding: '2px 10px', borderRadius: '12px',
              fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.5px'
            }}>
              {getRoleName()}
            </span>
          </div>

          {/* Divider */}
          <div style={{ height: '1px', background: '#f0f0f0' }} />

          {/* Logout Button */}
          <div style={{ padding: '10px 12px' }}>
            <button
              onClick={logout}
              disabled={loading}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '8px 0',
                background: loading ? '#ccc' : 'linear-gradient(135deg, #ff4e4e, #c0392b)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '0.82rem',
                fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'opacity 0.2s'
              }}
            >
              <FaSignOutAlt />
              {loading ? 'Logging out...' : 'Logout'}
            </button>
          </div>

        </div>
      </Collapse>
    </div>
  );
};

TopbarProfile.propTypes = {
  user: UserProps,
};

export default TopbarProfile;
